export default __webpack_public_path__ + "static/media/animal-42.db86b736.svg";